<template>
  <AppView :title="title" :backable="true" :deskHeader="false">
    <main
      data-desktop-policy
      class="min-w-0 bg-white desk:min-h-0 desk:flex-1"
    >
      <div
        class="min-w-0 desk:grid desk:min-h-[calc(100vh-3.5rem)] desk:grid-cols-2 desk:items-stretch"
      >
        <section class="hidden desk:block desk:border-r desk:border-gray-100">
          <div class="desk:sticky desk:top-14 desk:px-12 desk:py-10">
            <p class="text-xs font-medium text-gray-400 desk:text-dove-gray">條款</p>
            <h1 class="mt-2 text-3xl font-bold text-gray-900">{{ title }}</h1>
            <p class="mt-3 text-sm leading-6 text-gray-500">
              請閱讀私隱政策說明。
            </p>
          </div>
        </section>

        <section class="px-2 desk:px-12 desk:py-10">
          <h1 class="mt-4 text-center text-lg font-bold desk:hidden">
            {{ title }}
          </h1>
          <div
            v-if="rules"
            class="tracking-wider desk:max-w-[65ch] desk:tracking-normal"
          >
            <div
              class="reader mb-1 whitespace-pre-wrap text-sm leading-5 tracking-widest text-chicago desk:leading-7 desk:tracking-normal"
              v-html="rules"
            />
          </div>
          <p
            v-else
            class="py-10 text-center text-sm text-gray-400 desk:py-0 desk:text-left"
          >
            暫無私隱政策內容
          </p>
        </section>
      </div>
    </main>
  </AppView>
</template>

<script>
const path = "teams/policies/privacy";
import { mapGetters } from "vuex";
export default {
  auth: false,
  head() {
    const info = this.$store.getters["app/info"];
    const imgs = this.$store.getters["app/imgs"];
    const privacy = info.docs.privacy;
    const title = privacy.title;
    const content = privacy.content;
    return {
      title: `${info.name}-${title}`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: `${info.name},${info.name}${title}`,
        },
        {
          hid: "description",
          name: "description",
          content: content,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: `${info.name}-${title}`,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: `${info.name}`,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/${path}`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: content,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: imgs.logo,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      info: "app/info",
    }),
    title() {
      return this.info.docs.privacy.title;
    },
    rules() {
      return this.info.docs.privacy.content;
    },
  },
};
</script>

<style lang="scss" scoped></style>
